import actions from './actions'

export default function WorkOrderStatusFormsReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_WORKORDERSTATUSFORM:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_WORKORDERSTATUSFORM:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_WORKORDERSTATUSFORM:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_WORKORDERSTATUSFORM:
      return {
        ...state,
        editing: { workOrderStatusFormID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_WORKORDERSTATUSFORM_RECIEVED ||
      actions.UPDATE_WORKORDERSTATUSFORM_RECIEVED ||
      actions.DELETE_WORKORDERSTATUSFORM_RECIEVED:
      return {
        ...state,
        editing: { workOrderStatusFormID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
